import { useRoutes } from 'react-router-dom';

import NotFound from '../components/NotFound/NotFound';
import LayoutPage from '../layout/LayoutPage';
import Home from '../pages/Home/Home';
import Invoice from '../pages/Invoice/Invoice';
import PaymentSuccess from '../pages/PaymentSuccess/PaymentSuccess';
import TrackPackage from '../pages/TrackPackage/TrackPackage';
import { HOME, INVOICE, PAYMENT, TRACKPACKAGE } from './routeConstants';

export default function Router() {
  return useRoutes([
    {
      path: HOME,
      element: <LayoutPage />,
      children: [{ path: HOME, element: <Home /> }],
    },

    {
      path: `${TRACKPACKAGE}/:packageId`,
      element: <TrackPackage />,
    },

    {
      path: INVOICE,
      element: <Invoice />,
    },

    {
      path: PAYMENT,
      element: <PaymentSuccess />,
    },

    { path: '*', element: <NotFound /> },
  ]);
}
